import { projectsApi } from '../api/projects';

/**
 * Download the project backup zip and start a browser save.
 * Shared by the book menu and Project Settings.
 */
export async function downloadProjectBackup(project) {
  const response = await projectsApi.downloadBackup(project.id);
  const blob = await response.blob();
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  const fallbackSlug = (project.name || 'project')
    .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'project';
  const filename = match
    ? match[1]
    : `${fallbackSlug}-backup-${new Date().toISOString().slice(0, 10)}.zip`;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
